// src/_helpers/estabelecimentoOrigem.helper.js
import get from 'lodash/get';

export function resolveEstabelecimentoOrigemId(userService) {
  try {
    if (userService && typeof userService.getExtension === 'function') {
      const ext = userService.getExtension(); // <- já é o idEstabelecimento
      if (ext != null && ext !== '') return Number(ext);
    }
  } catch (_) { /* no-op */ }
  return null;
}

export function ensureEstabelecimentoOrigem(formRef, { userService } = {}) {
  if (!formRef || !formRef.state || !formRef.state.values) return;
  const atual = get(formRef.state.values, 'estabelecimentoOrigemId');
  if (atual) return;

  const resolved = resolveEstabelecimentoOrigemId(userService);
  if (resolved != null && typeof formRef.setFieldValue === 'function') {
    formRef.setFieldValue('estabelecimentoOrigemId', resolved);
  }
}

// Opcional: export default apontando para a função principal que você usa
export default ensureEstabelecimentoOrigem;
